export default __webpack_public_path__ + "static/media/img-adolescent.58b1a692.svg";